export default __webpack_public_path__ + "static/10-b890b3a8530b0832ff940c290da78ed9.webp";